import { useMutation, useQuery, useQueryClient } from "react-query";
import * as api from "../api/ServiceApi";

//////////////////////////////////////////////////////
//-------------------- ACTIVITY --------------------//
//////////////////////////////////////////////////////
//--- get all activities ---//
export const GetActivities = () => {
  return useQuery(["activities"], api.fetchActivities);
};

//--- get activity by id ---//
export const GetActivity = (activityId) => {
  const queryClient = useQueryClient();
  return useQuery(["activity", activityId], api.fetchActivity, {
    initialData: () => {
      const activity = queryClient
        .getQueryData("activity")
        ?.data.find((activity) => activity.id === parseInt(activityId));
      if (activity) {
        return {
          data: activity,
        };
      } else {
        return undefined;
      }
    },
  });
};
//--- create activity ---//
export const CreateActivity = () => {
  return useMutation(api.postActivity);
};

//--- update activity ---//
export const UpdateActivity = () => {
  return useMutation(api.putActivity);
};

//--- delete activity ---//

//////////////////////////////////////////////////////
//-------------------- MATERIAL --------------------//
//////////////////////////////////////////////////////

//--- get materials ---//
export const GetMaterials = () => {
  return useQuery(["materials"], api.fetchMaterials);
};

//--- get material ---//
export const GetMaterial = (materialId) => {
  const queryClient = useQueryClient();
  return useQuery(["material", materialId], api.fetchMaterial, {
    initialData: () => {
      const material = queryClient
        .getQueryData("material")
        ?.data.find((material) => material.id === parseInt(materialId));
      if (material) {
        return {
          data: material,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create material ---//
export const CreateMaterial = () => {
  return useMutation(api.postMaterial);
};

//--- update material ---//
export const UpdateMaterial = () => {
  return useMutation(api.putMaterial);
};

//--- delete material ---//

/////////////////////////////////////////////////////
//-------------------- SERVICE --------------------//
/////////////////////////////////////////////////////
//--- get services ---//
export const GetServices = () => {
  return useQuery(["services"], api.fetchServices);
};

//--- get service ---//
export const GetService = (serviceId) => {
  const queryClient = useQueryClient();
  return useQuery(["service", serviceId], api.fetchService, {
    initialData: () => {
      const service = queryClient
        .getQueryData("service")
        ?.data?.find((service) => service.id === parseInt(serviceId));
      if (service) {
        return {
          data: service,
        };
      } else {
        return undefined;
      }
    },
  });
};

//--- create service ---//
export const CreateService = () => {
  return useMutation(api.postService);
};

//--- update service ---//
export const UpdateService = () => {
  return useMutation(api.putService);
};

//--- delete service ---//

//////////////////////////////////////////////////////////
//-------------------- SERVICEGROUP --------------------//
//////////////////////////////////////////////////////////

//--- get servicegroups ---//
export const GetServiceGroups = () => {
  return useQuery(["servicegroups"], api.fetchServiceGroups);
};

//--- get servicegroup ---//
export const GetServiceGroup = (serviceGroupId) => {
  const queryClient = useQueryClient();
  return useQuery(["servicegroup", serviceGroupId], api.fetchServiceGroup, {
    initialData: () => {
      const serviceGroup = queryClient
        .getQueryData("serviceGroup")
        ?.data.find(
          (serviceGroup) => serviceGroup.id === parseInt(serviceGroupId)
        );
      if (serviceGroup) {
        return { data: serviceGroup };
      } else {
        return undefined;
      }
    },
  });
};

//--- create servicegroup ---//
export const CreateServiceGroup = () => {
  return useMutation(api.postServiceGroup);
};

//--- update servicegroup ---//
export const UpdateServiceGroup = () => {
  return useMutation(api.putServiceGroup);
};

//--- delete servicegroup ---//
